import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button, Dropdown, Menu, Tag, Popover, Modal, Collapse, notification, Radio, Divider, Checkbox } from "antd";
import { EditOutlined, MoreOutlined, DeleteOutlined, PrinterOutlined, ExclamationCircleOutlined, ArrowUpOutlined, ArrowDownOutlined, CloudUploadOutlined, EyeOutlined } from "@ant-design/icons";
import moment from 'moment';

import DrawerCliente from './drawer';
import api from '../../services/api';
import { useStateValue } from '../../state';
import { FormatFone, MaskFormat } from "../../ValueObjects";
import { getEmpresa, getIdUsuario, getLocal } from "../../services/auth";
import { drawerActions, listagemActions, manutencaoActions } from "../../actions";
import { PesquisaOrdenacao, TabelaDados, Editar, Excluir, BreadcrumbPage, BotaoIncluirDados, PesquisaAvancada } from "../../components";


export default function Clientes() {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [formPesquisaAvancada] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [editando, setEditando] = useState(false);
    const [campoPerSelecionado, setCampoPerSelecionado] = useState({});
    const [tipoFiltroPersonalizado, setTipoFiltroPersonalizado] = useState(0);

    useEffect(() => {
        let _ativo = !!!formPesquisaAvancada.getFieldsValue().clienteAtivo ? 1 : formPesquisaAvancada.getFieldsValue().clienteAtivo;
        dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: `&ativo=${_ativo}`, filtro: '', ordem: '+pes_nome' } })
        formPesquisaAvancada.setFieldsValue({ clienteAtivo: 1 });
    }, []);

    const togglePesquisa = () => {
        setOpen(!open);
    };

    const menuOutros = () => {
        const items = [
            {
                key: '1',
                label: (
                    <Button type="text" icon={<CloudUploadOutlined />} onClick={() => {
                        dispatch({ type: manutencaoActions.CHANGE, data: { dados: { entidade: 0 } } });
                    }}>
                        <Link to="/importarPessoa"> Importar Cliente </Link>
                    </Button>
                )
            }
        ];

        return { items };
    };

    function aplicarFiltrosAvancados() {
        let outrosFiltros = '';
        outrosFiltros += `&Ativo=${formPesquisaAvancada.getFieldsValue().clienteAtivo}`;

        if (formPesquisaAvancada.getFieldValue().produtorRural) {
            outrosFiltros += `&ProdutorRural=${formPesquisaAvancada.getFieldValue().produtorRural}`;
        }
        let filtroPersonalizado = ""
        if (tipoFiltroPersonalizado == 1) {
            filtroPersonalizado = formPesquisaAvancada.getFieldsValue().filtroCampoAdicional
        } else if (tipoFiltroPersonalizado == 2) {
            filtroPersonalizado = formPesquisaAvancada.getFieldsValue()[campoPerSelecionado[0].cap_nomeelemento]
        }
        if (!!filtroPersonalizado || typeof filtroPersonalizado == 'boolean') {
            let filtros = { filtro_0: { cap_id: campoPerSelecionado[0].cap_id, cap_tipoelemento: campoPerSelecionado[0].cap_tipoelemento, condicao: formPesquisaAvancada.getFieldsValue().condicao, outrosFiltros: filtroPersonalizado } }
            outrosFiltros += `&filtroAdicional=${JSON.stringify(filtros)}`;
        }

        dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: outrosFiltros } });

    }

    function editarCliente(record) {
        setEditando(true);
        record.pef_datanascimento = moment(record.pef_datanascimento);
        record.pej_datafundacao = !!record.pej_datafundacao ? moment(record.pej_datafundacao) : null;
        record.cpfCnpj = !!record.pef_cpf ? record.pef_cpf : (!!record.pej_cnpj ? record.pej_cnpj : '');
        dispatch({ type: manutencaoActions.CHANGE, data: { dados: record } });
        dispatch({ type: drawerActions.CHANGE, data: { showDrawer: true } });
    };

    function excluirRegistro(cliente) {
        api.delete(`Cliente/Excluir/${cliente.cli_id}`).then(
            (res) => {
                notification.success({ message: 'Aviso', description: 'Cliente excluído com sucesso!' });
                dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: '', filtro: '', ordem: '+pes_nome' } });
            }).catch(
                (erro) => {
                    console.error(erro);
                    modalInativarRegistro(cliente);
                })
    };

    function inativarRegistro(cliente) {
        api.put(`cliente/InativarCliente/${cliente.cli_id}`).then((res) => {
            if (res.status === 200)
                dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: '', filtro: '', ordem: '+pes_nome' } });
        })
    };

    const modalExcluirRegistro = (cliente) => {
        console.log('cliente', cliente);
        Modal.confirm({
            title: 'Excluir?',
            icon: <ExclamationCircleOutlined />,
            content: `Deseja realmente excluir o cliente ${cliente.cli_codigo}-${cliente.pes_nome} ?`,
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                excluirRegistro(cliente);
            }
        });
    };

    const modalInativarRegistro = (cliente) => {
        Modal.confirm({
            title: 'Não foi possível excluir o cliente!',
            icon: <ExclamationCircleOutlined />,
            content: `Deve conter referências com outros registros,
            Deseja inativar o cliente ${cliente.cli_codigo}-${cliente.pes_nome} ?`,
            okText: 'Inativar',
            cancelText: 'Cancelar',
            centered: true,
            onOk() {
                inativarRegistro(cliente);
            }
        });
    };

    function menuTable(cliente) {
        const items = [
            {
                key: '1',
                label: (
                    <Button type="text" icon={<PrinterOutlined />} onClick={() => { imprimirCliente(cliente) }}> Ficha Cliente </Button>
                )
            },
            {
                key: '2',
                label: (
                    <Button type="text" icon={<EyeOutlined />}>
                        <Link to="/resumoCliente" onClick={() => {
                            dispatch({ type: manutencaoActions.CHANGE, data: { dados: cliente } });
                        }}>
                            Informações Detalhadas
                        </Link>
                    </Button>
                )
            }
        ]

        return { items };
    }
    function download(dadosBase64, nomeArquivo) {
        //var dadosBase64 = "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"

        const link = document.createElement('a');
        link.href = "data:application/octet-stream;base64," + dadosBase64;
        link.download = nomeArquivo;
        link.click();
    }
    function imprimirCliente(record) {
        let parametros = [{ nome: "empresaLogado", valor: getEmpresa() }, { nome: "localLogado", valor: getLocal() }, { nome: "usuarioLogado", valor: getIdUsuario() }, { nome: 'codigoCliente', valor: record.cli_id }];

        let urlRel = {
            PathRelatorio: "Cliente/FichaIndividual_001/FichaIndividual",
            Parametros: JSON.stringify(parametros),
            Tipo: "PDF",
            NomeRelatorio: "Ficha Individual de Cliente"
        }

        api.post(`RelatorioJasper/RetornaDadosRelatorios`, urlRel).then(
            res => {
                if (urlRel.Tipo === 'PDF') {
                    var byteCharacters = atob(res.data);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (var i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                } else {
                    download(res.data, res.data.fileDownloadName);
                }
            }).catch(
                erro => {
                    console.error(erro);
                    alert('Erro ao gerar Relatório: ' + erro);
                }
            );
    };

    function pesquisaAvancada(expressao) {
        dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: `&ativo=${formPesquisaAvancada.getFieldValue().clienteAtivo}&ProdutorRural=${formPesquisaAvancada.getFieldValue().produtorRural}&filtroAdicional=${btoa(expressao)}`, ordem: '+pes_nome' } })
    };

    function limparFiltroPesquisa() {
        dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: `&ativo=${formPesquisaAvancada.getFieldValue().clienteAtivo}`, ordem: '+pes_nome' } })

    };

    return (
        <div className="p-10">
            <Row align="middle" justify="space-between" className="col-pagina-breadcrumb" gutter={[8, 8]}>
                <Col className="col-w-100">
                    <BreadcrumbPage />
                </Col>
                <Col className="col-mob-100">
                    <Row align="middle" justify="end">
                        <Col>
                            <BotaoIncluirDados />
                        </Col>
                        <Col>
                            <Dropdown menu={menuOutros()} trigger={['click']}>
                                <Button size="middle" onClick={e => e.preventDefault()} icon={<MoreOutlined />} />
                            </Dropdown>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Form layout="vertical" name="formularioPesqAvancadaClientes" form={formPesquisaAvancada} onFinish={aplicarFiltrosAvancados}>
                <Row gutter={[8, 0]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={14} xxl={16}>
                        <PesquisaOrdenacao opcoesOrdenacao={[
                            { label: "Nome A - Z", value: "+pes_nome" },
                            { label: "Nome Z - A", value: "-pes_nome" },
                            { label: "Código Crescente", value: "+cli_codigo" },
                            { label: "Código Decrescente", value: "-cli_codigo" }
                        ]} />
                    </Col>
                    <Col xs={24} sm={24} md={9} lg={9} xl={6}>
                        <Form.Item label="Selecione Status do Cliente" name="clienteAtivo">
                            <Radio.Group onChange={() => aplicarFiltrosAvancados()}>
                                <Radio value={2}>Todos</Radio>
                                <Radio value={1}>Ativo</Radio>
                                <Radio value={0}>Inativo</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>

                <Row align="middle" gutter={[0, 8]}>
                    <Col span={24}>
                        <Collapse className="p-relative mt-coll" accordion ghost destroyInactivePanel={true}>
                            <div className="colDet"></div>
                            <Collapse.Panel key="1" showArrow={false} extra={
                                <Button type="primary" onClick={togglePesquisa} block>
                                    {open ? <ArrowUpOutlined /> : <ArrowDownOutlined />} Realizar pesquisa avançada
                                </Button>
                            }>
                                <Col>
                                    <Form.Item name="produtorRural" valuePropName="checked">
                                        <Checkbox onChange={() => aplicarFiltrosAvancados()}> Produtor Rural </Checkbox>
                                    </Form.Item>
                                </Col>
                                <PesquisaAvancada form={formPesquisaAvancada} funcaoRetorno={(ret) => { pesquisaAvancada(ret) }} funcaoLimpar={() => { limparFiltroPesquisa() }} telaFiltro={1} />
                            </Collapse.Panel>
                        </Collapse>
                    </Col>
                </Row>
            </Form>
            <div className="tabela">
                <TabelaDados url="cliente/listar" colunas={[
                    {
                        title: 'Código',
                        width: 75,
                        align: 'center',
                        render: ({ cli_codigo, cli_ativo }) => (
                            <Popover content={cli_ativo ? 'Ativo' : 'Inativo'} placement="right">
                                <Tag color={cli_ativo ? 'processing' : 'default'} className="w-100">
                                    <b>{cli_codigo}</b>
                                </Tag>
                            </Popover>
                        ),
                    },
                    {
                        title: 'Cliente',
                        render: ({ pes_nome }) => (
                            <div>
                                <b>{pes_nome}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Nome Fantasia',
                        render: ({ pej_nomefantasia, pef_apelido }) => (
                            <div>
                                <b>{pej_nomefantasia ?? (pef_apelido ?? 'Não Informado')}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'CPF/CNPJ',
                        width: 138,
                        render: ({ pef_cpf, pej_cnpj }) => (
                            <div>
                                <b>{!!pef_cpf ? MaskFormat(pef_cpf, 'Não Informado', true) : MaskFormat(pej_cnpj, 'Não Informado', true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Telefone',
                        width: 120,
                        render: ({ psc_numero, pes_fisicajuridica }) => (
                            <div>
                                <b>{(pes_fisicajuridica == 3 ? (psc_numero || 'Não Informado') : FormatFone(psc_numero) || 'Não Informado')}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Endereço',
                        render: ({ log_logradouro, pee_numero, bai_nome, cep_cep, cid_descricao, est_sigla }) => (
                            <div>
                                <b>{log_logradouro || 'Não Informado'}{(!!pee_numero) ? (', ' + pee_numero) : ''}{!!(bai_nome) ? (', ' + bai_nome) : ''} {!!(cep_cep) ? ('- ' + cep_cep) : ''} {!!(cid_descricao) ? ('- ' + cid_descricao) : ''} {!!(est_sigla) ? ('- ' + est_sigla) : ''}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Ações',
                        dataIndex: '',
                        align: 'center',
                        fixed: 'right',
                        key: 'x',
                        width: 95,
                        render: (record) => (
                            <div>
                                <Row align="middle" justify="center" gutter={[5, 0]}>
                                    <Col>
                                        <Editar onClick={() => editarCliente(record)} icon={<EditOutlined />} />
                                    </Col>
                                    <Col>
                                        <Excluir onClick={() => { modalExcluirRegistro(record) }} icon={<DeleteOutlined />} />
                                    </Col>
                                    <Col>
                                        <Dropdown menu={menuTable(record)} trigger={['click']}>
                                            <Button onClick={e => e.preventDefault()} icon={<MoreOutlined />} />
                                        </Dropdown>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                ]} expandir={({ pef_rg, pej_inscricaoestadual, pem_email }) => {
                    return (
                        <div>
                            <Row align="middle" gutter={[16, 0]}>
                                {!!pef_rg ? <Col>
                                    RG: <b>{pef_rg}</b>
                                </Col> : null}
                                {!!pej_inscricaoestadual ? <Col>
                                    IE: <b>{pej_inscricaoestadual}</b>
                                </Col> : null}
                                <Col>
                                    E-mail: <b>{pem_email || 'Não Informado'}</b>
                                </Col>
                            </Row>
                        </div>
                    )
                }} />
            </div>
            <DrawerCliente editando={{ editando, setEditando }} />
        </div>
    );

}